import React, { useMemo } from 'react';
// @ts-expect-error - TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'HeadType'. Did you mean to use 'import HeadType from "@atlaskit/dynamic-table"' instead? | TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'RowType'. Did you mean to use 'import RowType from "@atlaskit/dynamic-table"' instead?
import type { HeadType, RowType } from '@atlaskit/dynamic-table';
import { Field } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import { useIntl } from '@atlassian/jira-intl';

import type { ThirdPartyMembers, UserEmails } from '../../common/types';
import messages from './messages';

export type FormData = { [key: string]: string };

export const convertFormDataToUserEmails = (formData: FormData): UserEmails => {
	const userEmails: UserEmails = {};
	Object.keys(formData).forEach((key) => {
		const emailId = formData[key];
		if (emailId && emailId.length > 0) {
			userEmails[key] = { emailId };
		}
	});

	return userEmails;
};

export const useTableHead = () => {
	const { formatMessage } = useIntl();
	const tableHead = useMemo<HeadType>(
		() => ({
			cells: [
				{
					key: 'user',
					content: formatMessage(messages.user),
					isSortable: true,
					shouldTruncate: true,
				},
				{
					key: 'arrow',
					width: 5,
				},
				{
					key: 'email',
					content: formatMessage(messages.email),
				},
			],
		}),
		[formatMessage],
	);

	return tableHead;
};

export const useTableRows = (members: ThirdPartyMembers[] | null, userEmails: UserEmails) => {
	const { formatMessage } = useIntl();
	const tableRows = useMemo<RowType[] | undefined>(
		() =>
			members?.map((member: ThirdPartyMembers) => ({
				key: `row-${member.id}`,
				cells: [
					{
						key: member.fullName,
						content: member.fullName,
					},
					{
						key: `${member.id}-arrow`,
						content: '→',
					},
					{
						key: `${member.id}-email`,
						content: (
							<Field
								name={member.id}
								defaultValue={userEmails[member.id]?.emailId || ''}
								label={`${member.fullName} email`}
							>
								{({ fieldProps }) => (
									<Textfield
										type="email"
										{...fieldProps}
										placeholder={formatMessage(messages.textFieldPlaceholder)}
									/>
								)}
							</Field>
						),
					},
				],
			})),
		[formatMessage, members, userEmails],
	);

	return tableRows;
};
